/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '../../../../SharedModules/Table/tableGrid';
import PDFExportPanel from '../../../../SharedModules/pdfExport/PDFExportPanel';
import {
  checkTableHead,
  checkTableWithOutBatchHead,
  checkTableWithOutCCNHead,
  checkTableWithOutBatchCCNHead,
} from './checkTableHead';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default function TableGrid(props) {
  const dispatch = useDispatch();
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(gridRef);
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const gridStyle = useMemo(() => ({ height: '250px', width: '100%' }), []);
  const [columnApi, setColumnApi] = useState(null);
  const [rowData, setRowData] = useState(props.searchResults);
  const [isFilter, setIsFilter] = useState(false);
  const [columnDefs, setColumnDefs] = useState(props.cellHead);

  const frameworkComponents = {
    CheckBox: (cellInfo) => {
      return (
        <>
          <div className="tbl-checkbox">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              checked={cellInfo.value}
              value={cellInfo.value}
            />
          </div>
        </>
      );
    },
    checkIssuerRender: (cellInfo) => {
      const name = cellInfo?.data?.checkIssuer;
      if (name && name.length > 22) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    batchNumRender: (cellInfo) => {
      const name = cellInfo && cellInfo.data && cellInfo.data.batchNum;
      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    ccnRender: (cellInfo) => {
      const name = cellInfo && cellInfo.data && cellInfo.data.checkIdentifier;
      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
    CheckAmtCellRender: (cellInfo) => {
      const isNegativeVal = !(
        parseFloat(cellInfo?.data?.checkAmt?.toString()?.split('$')[1]) >= 0
      );
      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: '#eb0000' }}>{`(${cellInfo?.data?.checkAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.checkAmt}`}</div>
          )}
        </>
      );
    },
    TotAllocatedAmtCellRender: (cellInfo) => {
      const isNegativeVal = !(
        parseFloat(
          cellInfo?.data?.totAllocatedAmt?.toString()?.split('$')[1]
        ) >= 0
      );
      return (
        <>
          {isNegativeVal ? (
            <div
              style={{ color: '#eb0000' }}
            >{`(${cellInfo?.data?.totAllocatedAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.totAllocatedAmt}`}</div>
          )}
        </>
      );
    },
    checkInfoRenderer:(cellInfo)=>{
      const name = cellInfo &&  cellInfo.data &&  cellInfo.data.checkInfo
      if (name && name.length > 20) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>
    }
  };

  const [filterRest, setFilterRest] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [totalResultCount, setTotalResultCount] = useState(0);
  const gridHeight = fullScreenView ? '70vh' : 400;
  const childRef = useRef(null);
  const getRowId = useCallback((params) => {
    // return params.data.processId
  }, []);

  // On Filter Change
  const onFilterChangedGrid = useCallback((e) => {
    setTotalResultCount(e.api.getDisplayedRowCount());
    const filterLength = Object.keys(e.api.getFilterModel()).length;
    if (filterLength > 0) setIsFilter(true);
    else setIsFilter(false);
  }, []);

  const onRowClickedGrid = (e) => {
    const a = e.api.getSelectedRows()?.[0];
    // const a = e.rowIndex;
    props.getIndexSelected(a);
  };
  const handleClearFilter = () => {
    childRef.current.clearFilters();
    setFilterRest(false);
  };
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
  }, []);
  useEffect(() => {
    setRowData(props.searchResults);
  }, [props.searchResults]);
  return (
    <>
      <div className="tab-height devider-line ">
        <div className="float-left mt-2 ml-3">
          <p className="no-margin tbl-help-text p-1">
            * On Double Click of the record to view the details{' '}
          </p>
        </div>

        <div className="float-right th-icon-group mt-2">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="filter-tooltip">Reset All Filters</Tooltip>}
          >
            {isFilter ? (
              <div
                className="th-icon ic-filter-activate"
                onClick={handleClearFilter}
              >
                <span className="ic-title"> Filter </span>{' '}
              </div>
            ) : (
              <div className="th-icon ic-filter">
                <span className="ic-title"> Filter </span>{' '}
              </div>
            )}
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="history-tooltip"> Actions </Tooltip>}
          >
            <div className="th-icon ic-actions">
              <PDFExportPanel
                gridApi={gridApi}
                columnApi={columnApi}
                fileName="Check Search"
                isScrollOn
                childRef={childRef}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="fullScreen-tooltip">
                {fullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
              </Tooltip>
            }
          >
            <div
              className={
                fullScreenView
                  ? 'th-icon ic-fulScreen-exit'
                  : 'th-icon ic-fulScreen'
              }
              onClick={() => {
                setFullScreenView(!fullScreenView);
                props.setFullScreenView(!fullScreenView);
              }}
            >
              <span className="ic-title">
                {' '}
                {fullScreenView ? 'Minimize Screen' : 'Full Screen'}{' '}
              </span>
            </div>
          </OverlayTrigger>
        </div>
        <div className="clearfix" />
      </div>

      <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
        <Grid
          onGridReady={onGridReady}
          ref={childRef}
          rowData={rowData}
          columnDefs={
            props.disableCCN && props.disableBatch
              ? checkTableWithOutBatchCCNHead
              : props.disableCCN
              ? checkTableWithOutCCNHead
              : props.disableBatch
              ? checkTableWithOutBatchHead
              : checkTableHead
          }
          setGridApi={setGridApi}
          fileName="Check Search"
          isScrollOn
          setColumnApi={setColumnApi}
          gridHeight={gridHeight}
          cellClickedListener={onRowClickedGrid}
          onFilterChanged={onFilterChangedGrid}
          setTotal={setTotalResultCount}
          frameworkComponents={frameworkComponents}
        />
      </div>
      <div className="float-left mt-2 ml-3">
        <p className="total-results" tabIndex="0">
          Total Results:
          <b>{totalResultCount?.toLocaleString('en-US')}</b>
        </p>
      </div>
    </>
  );
}
